module.exports = __webpack_public_path__ + "static/img/91064B_20171015_R_2_3_4_LC.3b09074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/91064B_20171015_R_2_3_4_LC.png
// module id = 7M4e
// module chunks = 0